import { ThemeProvider } from '@mui/material/styles';
import { ErrorBoundary } from '@sentry/react';
import { SidebarProvider } from '@shared/components/ui/sidebar';
import { Toaster } from '@shared/components/ui/toaster';
import { HistoryProvider } from '@shared/providers/history-provider';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { NuqsAdapter as NuqsRouterAdapter } from 'nuqs/adapters/react-router/v6';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import ApiProvider from './api/api-provider';
import { AuthProvider } from './auth/auth-provider';
import Layout from './components/layout/app-layout';
import { AnalyticsProvider } from './services/analytics/AnalyticsProvider';
import { IntercomProvider } from './services/intercom/IntercomProvider';
import theme from './styles/Styles';

function App() {
  return (
    <NuqsAdapter>
      <ErrorBoundary
        fallback={
          <div className="flex h-screen items-center justify-center">
            <h1>An error has occurred</h1>
          </div>
        }
      >
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <AnalyticsProvider>
              <IntercomProvider>
                <ApiProvider>
                  <SidebarProvider className="w-full bg-gray-25">
                    <Router>
                      {/* Everything inside the Router must use the react-router
                          adapter: it reads/writes through react-router's own
                          location state, so URL params set by <Link> navigation
                          and nuqs stay in sync both ways. The plain adapter at
                          the root only sees nuqs-initiated updates. */}
                      <NuqsRouterAdapter>
                        <HistoryProvider>
                          <Layout>
                            <Routes />
                          </Layout>
                        </HistoryProvider>
                      </NuqsRouterAdapter>
                    </Router>
                    <Toaster />
                  </SidebarProvider>
                </ApiProvider>
              </IntercomProvider>
            </AnalyticsProvider>
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </NuqsAdapter>
  );
}

export default App;
